export default __webpack_public_path__ + "20ae7e41e38f75d09df2e8f95b859aab.png";